import { EvaEndpoint } from '@springtree/eva-sdk-core-service';
import { setCoreSetting } from '@springtree/eva-sdk-core-settings';
import { cache } from 'react';
import { EVA_API_URL } from '@/core/constants/env';
import packageJson from '../../../../package.json';

setCoreSetting('appName', packageJson.name);
setCoreSetting('appVersion', packageJson.version);

const getEndpoint = cache(() => new EvaEndpoint(EVA_API_URL));

export default getEndpoint;
